/* =========================================================
   莉々庵 × 佐久良 — ly.js
   ヘッダー / SPメニュー / スクロールフェード / 商品カード（数量・価格表示）
   元: lilyan-sakura-ec/js/front.js を移植
   ========================================================= */
(function () {
  'use strict';

  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  /* ---------- ヘッダー ---------- */
  var header = $('.ly-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('ly-is-scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var menuBtn = $('#LyMenuBtn');
    var gnav = $('#LyGnav');
    if (menuBtn && gnav) {
      var setMenu = function (open) {
        menuBtn.setAttribute('aria-expanded', String(open));
        menuBtn.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
        gnav.classList.toggle('ly-is-open', open);
        header.classList.toggle('ly-menu-open', open);
        document.body.classList.toggle('ly-is-locked', open);
      };
      menuBtn.addEventListener('click', function () { setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'); });
      $$('a', gnav).forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && gnav.classList.contains('ly-is-open')) setMenu(false);
      });
    }
  }

  /* ---------- スクロールフェード ---------- */
  var initFades = function (root) {
    var fades = $$('.ly-fade:not(.ly-is-in)', root);
    if (!('IntersectionObserver' in window)) {
      fades.forEach(function (el) { el.classList.add('ly-is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ly-is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    fades.forEach(function (el) { io.observe(el); });
  };
  initFades(document);
  // 念のため：IntersectionObserverが動かない環境でも3秒後に全表示
  setTimeout(function () { $$('.ly-fade').forEach(function (el) { el.classList.add('ly-is-in'); }); }, 3000);

  /* ---------- 商品カード：数量ボタン ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ly-qty__btn');
    if (!btn) return;
    var input = $('.ly-qty__input', btn.closest('.ly-qty'));
    var v = (parseInt(input.value, 10) || 1) + (btn.dataset.step === 'up' ? 1 : -1);
    input.value = Math.max(1, Math.min(99, v));
  });

  /* ---------- テーマエディタでの再描画 ---------- */
  document.addEventListener('shopify:section:load', function (e) { initFades(e.target); });
})();
